<template>
  <Breadcrumb :items="breadcrumbs" />
  <div class="form-page">
    <div class="form-page-header">
      <div class="form-page-header__icon">
        <i class="pi pi-lock"></i>
      </div>
      <div class="form-page-header__text">
        <h1 class="form-page-header__title">تعديل كلمة المرور</h1>
        <p class="form-page-header__subtitle" v-if="student_name">{{ student_name }}</p>
      </div>
    </div>

    <div class="container-fluid">
      <div class="password-page-layout">
        <div class="form-card">
          <div class="form-card__header">
            <div class="form-card__header-icon"><i class="pi pi-key"></i></div>
            <span class="form-card__title">كلمة المرور الجديدة</span>
          </div>
          <div class="form-card__body">
            <form @submit.prevent="sendForm()">
              <div class="form-field">
                <label class="field-label">كلمة المرور <span class="required">*</span></label>
                <div class="password-field-wrapper">
                  <InputText
                    id="newPassword"
                    v-model="new_password"
                    :type="showPassword ? 'text' : 'password'"
                    placeholder="أدخل كلمة المرور الجديدة"
                    class="w-100"
                  />
                  <button type="button" class="password-toggle" @click="showPassword = !showPassword" :title="showPassword ? 'إخفاء' : 'إظهار'">
                    <i :class="showPassword ? 'pi pi-eye-slash' : 'pi pi-eye'"></i>
                  </button>
                </div>
                <span class="field-error" v-if="v$.new_password.$error">
                  <i class="pi pi-exclamation-circle"></i> برجاء إدخال كلمة المرور الجديدة
                </span>
              </div>

              <!-- Password strength -->
              <div class="password-strength" v-if="new_password">
                <div class="password-strength__bars">
                  <span
                    v-for="n in 4"
                    :key="n"
                    :class="['password-strength__bar', n <= passwordStrengthLevel ? `password-strength__bar--${passwordStrengthColor}` : '']"
                  ></span>
                </div>
                <span class="password-strength__label" :style="{ color: passwordStrengthCSSColor }">
                  {{ passwordStrengthLabel }}
                </span>
              </div>

              <div class="form-actions" style="margin-top: 1.5rem;">
                <button type="submit" class="btn-submit" :disabled="formSending">
                  <i class="pi pi-spin pi-spinner-dotted" v-if="formSending"></i>
                  <i class="pi pi-check" v-else></i>
                  {{ formSending ? 'جاري الحفظ...' : 'حفظ كلمة المرور' }}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import InputText from 'primevue/inputtext';
import InputNumber from 'primevue/inputnumber';
import Swal from 'sweetalert2';
import useVuelidate from "@vuelidate/core";
import { required } from "@vuelidate/validators";
import Dropdown from 'primevue/dropdown';
import Breadcrumb from "@/components/global/breadcrumb.vue";
import { useGradeStore } from '@/stores/useGradeStore.js';

export default {
  name: "user-edit",
  data() {
    return {
      v$: useVuelidate(),
      user: {},
      new_password: "",
      student_name: "",
      student_phone: null,
      parent_phone: null,
      address: "",
      math_degree: null,
      certificate_image: "",
      imageEntry: "",
      fileData: "",
      selected_gender: null,
      selected_type: null,
      academic_year_id: null,
      path: null,
      genders: [
        { name: 'ولد', id: 1 },
        { name: 'بنت', id: 2 },
      ],
      types: [
        { name: 'عام', id: 1 },
        { name: 'أزهر', id: 2 },
      ],
      formSending: false,
      showPassword: false,
      user_id: this.$route.params.id,
    }
  },
  components: {
    InputText,
    InputNumber,
    Dropdown,
    Breadcrumb
  },
  validations() {
    return {
      new_password: { required },
      // address: { required },
      // math_degree: { required },
    };
  },
  computed: {
    gradeStore() { return useGradeStore(); },
    resolvedGrade() {
      if (!this.academic_year_id) return null;
      return this.gradeStore.allGrades.find(g => g.id === this.academic_year_id)
          || this.gradeStore.activeGrades.find(g => g.id === this.academic_year_id)
          || null;
    },
    passwordStrengthLevel() {
      const p = this.new_password;
      if (!p) return 0;
      let score = 0;
      if (p.length >= 8) score++;
      if (/[A-Z]/.test(p)) score++;
      if (/[0-9]/.test(p)) score++;
      if (/[^A-Za-z0-9]/.test(p)) score++;
      return score;
    },
    passwordStrengthColor() {
      const lvl = this.passwordStrengthLevel;
      if (lvl <= 1) return 'danger';
      if (lvl <= 2) return 'warning';
      return 'success';
    },
    passwordStrengthCSSColor() {
      const lvl = this.passwordStrengthLevel;
      if (lvl <= 1) return 'var(--danger-color, #ef4444)';
      if (lvl <= 2) return 'var(--warning-color, #f59e0b)';
      return 'var(--success-color, #10b981)';
    },
    passwordStrengthLabel() {
      const lvl = this.passwordStrengthLevel;
      if (lvl <= 1) return 'ضعيفة';
      if (lvl === 2) return 'متوسطة';
      if (lvl === 3) return 'جيدة';
      return 'قوية جداً';
    },
    breadcrumbs() {
      const gradeName = this.resolvedGrade?.name ?? '';
      const gradePath = this.resolvedGrade ? `/grades/${this.resolvedGrade.slug}/students` : '/';
      return [
        { name: 'الرئيسية', path: '/' },
        { name: gradeName, path: gradePath },
        { name: 'تعديل كلمة المرور', path: this.$route.fullPath }
      ];
    }
  },
  methods: {
    sendForm() {
      this.v$.$validate();
      if (!this.v$.$error) {
        const formData = new FormData();
        formData.append('user_id', this.user_id);
        formData.append('password', this.new_password);

        this.formSending = true;

        axios
            .post('/update_password', formData)
            .then((response) => {
              this.formSending = false;
              Swal.fire({
                position: "center",
                icon: "success",
                title: "تم تحديث كلمة المرور بنجاح",
              });
            })
            .catch((error) => {
              this.formSending = false;
              Swal.fire({
                position: "center",
                icon: "error",
                title: error.response.data.message,
              });
            }).finally(() => {
              this.formSending = false;
            });
      }
    },
    fetchUserData() {
      const formData = new FormData();
      formData.append('user_id', this.$route.params.id);

      axios
          .post(`/get_user_dashboard`, formData)
          .then((response) => {
            this.user = response.data.user;
            this.student_name = this.user.name;
            this.student_phone = this.user.phone;
            this.parent_phone = this.user.parent_phone;
            this.address = this.user.address;
            this.math_degree = response.data.math_degree;
            this.gender = this.user.gender;
            this.selected_gender = this.genders.find(gen => gen.id === this.user.gender);

            this.education_type = this.user.education_type;
            this.selected_type = this.types.find(type => type.id === this.user.education_type);

            this.academic_year_id = this.user.academic_year_id ?? null;
            this.certificate_image = this.user.certificate_image;
          })
          .catch((error) => {
            this.reservations = {};
          });
    },
  },
  async mounted() {
    if (!this.gradeStore.allGrades.length) await this.gradeStore.fetchAllGrades();
    if (!this.gradeStore.activeGrades.length) await this.gradeStore.fetchActiveGrades();
    this.fetchUserData();
  }
}
</script>
